// This file reproduces the functionality of scribd_document_tracker.js in
// React hook form - but only for the 'pageChanged' event. This event is the
// source of the 'pages read' count for the Analytics page.

import { useCallback, useRef } from 'react';
import { useDebounceCallback } from 'usehooks-ts';

import routes from 'js/core_pre_webpack/routes';
import { keptAlivePost } from 'js/utils/kept_alive_post';

type BaseScribdEvent = {
  event: 'pageChanged';
  page: number;
};

type ScribdEvent = BaseScribdEvent & {
  ms_since_load: number;
};

const loadedAt = new Date().getTime();

export const useScribdEvents = (attachment_id: string) => {
  const events = useRef<ScribdEvent[]>([]);

  const flushEvents = useCallback(() => {
    if (events.current.length === 0) return;

    keptAlivePost(
      routes.api_v0_scribd_events_path({ subdomain_param: 'api' }),
      {
        attachment_id,
        events: JSON.stringify(events.current),
        hit: JSON.stringify(window.Aedu.hit_data),
      },
    );

    events.current = [];
  }, [attachment_id]);

  const flushEventsDebounced = useDebounceCallback(flushEvents, 1000);

  const enqueueEvent = useCallback(
    (event: BaseScribdEvent) => {
      events.current.push({
        ...event,
        ms_since_load: new Date().getTime() - loadedAt,
      });
      flushEventsDebounced();
    },
    [flushEventsDebounced],
  );

  return { enqueueEvent };
};
